export interface DeveloperPaths {
    DevReindex: string,
}

export const developerPaths: DeveloperPaths = {
    DevReindex: '/developer/reindex',
};